import { useEffect } from 'react';
import Cal, { getCalApi } from '@calcom/embed-react';

const CAL_LINK = 'abhineeth-srinivasa/15min';
const CAL_NAMESPACE = 'learn41-15min';

export default function InstitutionalCTA() {
  useEffect(() => {
    (async () => {
      const cal = await getCalApi({ namespace: CAL_NAMESPACE });
      cal('ui', {
        theme: 'light',
        cssVarsPerTheme: {
          light: {
            'cal-brand': '#D4A853',
            'cal-bg': '#F9F4E9',
            'cal-bg-emphasis': '#F1EADA',
            'cal-bg-subtle': '#F4EEDF',
            'cal-bg-muted': '#EDE4CE',
            'cal-text': '#1A1A1A',
            'cal-text-emphasis': '#000000',
            'cal-text-subtle': '#4A4A4A',
            'cal-text-muted': '#6B6B6B',
            'cal-border': '#D8CEB4',
            'cal-border-subtle': '#E5DCC6',
            'cal-border-emphasis': '#B8A87E',
          },
          dark: {},
        },
        hideEventTypeDetails: false,
        layout: 'month_view',
      });
    })();
  }, []);

  return (
    <section id="book-demo" className="bg-primary py-20 scroll-mt-20">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="font-playfair text-3xl md:text-5xl font-medium italic text-primary-foreground mb-4">
          Prepare your entire campus for placements
        </h2>
        <p className="text-primary-300 text-lg mb-4 max-w-2xl mx-auto leading-relaxed">
          It's an employer's market. CGPA alone doesn't cut it anymore. Give your placement cell the tools to assess every student properly, and the data to attract better companies.
        </p>

        <ul className="text-primary-300 text-left max-w-xl mx-auto mb-10 space-y-3">
          <li className="flex items-start gap-2">
            <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-primary-accent-500 shrink-0" />
            Assess all your students beyond CGPA with real interview simulations
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-primary-accent-500 shrink-0" />
            Know who's ready for Google vs Infosys, skill-based, not grade-based
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-primary-accent-500 shrink-0" />
            Showcase pre-vetted talent to attract higher-tier recruiters to your campus
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-primary-accent-500 shrink-0" />
            All interview types, coding, system design, case study, behavioral, one platform
          </li>
        </ul>

        <div className="rounded-xl overflow-hidden shadow-lg" style={{ background: '#F9F4E9' }}>
          <Cal
            namespace={CAL_NAMESPACE}
            calLink={CAL_LINK}
            style={{ width: '100%', height: '100%', overflow: 'scroll' }}
            config={{ layout: 'month_view' }}
          />
        </div>
      </div>
    </section>
  );
}
